export const loadInstagramScript = () => {
    return new Promise((resolve, reject) => {
      if (window.instgrm) {
        resolve();
        return;
      }
  
      const script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Erreur de chargement du script Instagram'));
  
      document.body.appendChild(script);
    });
  };